<template>
  <IframeCovid />
</template>

<script>
import IframeCovid from '@/pages/iframe/IframeCovid.page.vue';
import MobileDetectionHook from '@/hooks/mobileDetection.hook';

export default {
  name: 'App',
  components: {
    IframeCovid,
  },
  setup() {
    MobileDetectionHook();
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
